module.exports = __webpack_public_path__ + "static/assets/b08053db99e46c6c4abe88ebe7b3eb92.png";